import React, { FC, memo, useEffect, useState } from 'react'

import { observer } from 'mobx-react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'

import PopupState, { bindPopover, bindTrigger } from 'material-ui-popup-state'

import Popover from '@mui/material/Popover'

import {
  EthereumChainId,
  getNetworkChainId,
  isAvailableMMProvider,
  UserRole,
} from 'utils'
import { useAuth, useMediaQuery } from 'utils/hooks'

import { useStore } from 'store'

import defaultUserPhoto from 'sources/images/defaultUser.svg'

import { NetworkIcon } from '../../NetworkIcon'

import styles from './styles.module.scss'

interface IProps {}

interface ParamTypes {
  nickName: string
}

export const AuthorizedUser: FC<IProps> = observer(() => {
  const navigate = useNavigate()
  const location = useLocation()
  const { profile, pageActivities, main } = useStore()
  const { logoutRedirect } = useAuth({})
  const width_1290 = useMediaQuery('(max-width: 1290px)')

  const { nickName } = useParams<keyof ParamTypes>()

  const [networkType, setNetworkType] = useState<any>('')

  const profileUserRole = profile.userRole || profile.userRoleSession
  const isBlockchainUser = profileUserRole === UserRole.BlockchainUser

  const redirectToProfile = () => {
    if (profile.selectedUser.NickName) {
      if (
        profile.selectedUser.NickName === nickName &&
        !location.pathname.includes('/user_videos/')
      )
        return
      pageActivities.setIsClickBack(false)
      navigate(`/user/${profile.selectedUser.NickName}`)
    }
  }

  const userAvatarImage = profile.selectedUser.ImageLink
    ? profile.selectedUser.ImageLink
    : defaultUserPhoto

  const AvatarImage = (
    <img src={userAvatarImage} alt="avatar" className={styles.profileAvatar} />
  )

  useEffect(() => {
    if (isAvailableMMProvider()) {
      const handleChainChange = () => getNetworkChainId().then(setNetworkType)

      handleChainChange()

      window.ethereum.on('chainChanged', handleChainChange)

      return () => {
        window.ethereum.removeListener('chainChanged', handleChainChange)
      }
    }
  }, [])

  return (
    <PopupState variant="popover" popupId="logged-user-menu">
      {popupState => {
        return (
          <React.Fragment>
            {width_1290 ? (
              <button
                {...bindTrigger(popupState)}
                className={styles.profileSmallBtn}
              >
                {AvatarImage}
              </button>
            ) : (
              <button
                {...bindTrigger(popupState)}
                className={styles.profileBtn}
              >
                {isBlockchainUser && (
                  <NetworkIcon
                    networkType={networkType === EthereumChainId ? 0 : 1}
                    className={styles.currencyIcon}
                  />
                )}

                {AvatarImage}
                <div className={styles.text}>
                  {!profile?.selectedUser?.DeletionMark
                    ? `@${profile.selectedUser.NickName}`
                    : 'Deleted User'}
                </div>
              </button>
            )}

            <Popover
              {...bindPopover(popupState)}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              sx={{
                '.MuiPaper-root': {
                  backgroundColor: 'transparent',
                  margin: '5px 0',
                },
              }}
            >
              <div className={styles.menuBox}>
                {!profile?.selectedUser?.DeletionMark && (
                  <button
                    onClick={() => {
                      popupState.close()
                      redirectToProfile()
                    }}
                    className={styles.menuItem}
                  >
                    <div className={styles.menuItemInner}>Go to Profile</div>
                  </button>
                )}

                <button onClick={logoutRedirect} className={styles.menuItem}>
                  <div className={styles.menuItemInner}>Log Out</div>
                </button>
              </div>
            </Popover>
          </React.Fragment>
        )
      }}
    </PopupState>
  )
})

AuthorizedUser.displayName = 'AuthorizedUser'

export default memo(AuthorizedUser)
